class PerformPasswordReset {
	constructor(
		public readonly token: string,
		public readonly password: string,
	) {
		Object.freeze(this);
	}

	// `token` is the route identifier: it must never be echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			password: this.password,
		};
	}
}

export default PerformPasswordReset;
